import React from 'react';
import {
  Box,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  HStack,
  useColorModeValue,
  VStack,
} from '@chakra-ui/react';
import OtpInput from 'react-otp-input';

interface IInputOtpProps {
  maxLength?: number;
  value?: string;
  onChange?: (value: string) => void;
  onComplete?: (value: string) => void;
  label?: string;
  helperText?: string;
  errorMessage?: string;
  isInvalid?: boolean;
  isDisabled?: boolean;
  placeholder?: string;
}

const InputOtp: React.FC<IInputOtpProps> = ({
  maxLength = 6,
  value = '',
  onChange,
  onComplete,
  label,
  helperText,
  errorMessage,
  isInvalid = false,
  isDisabled = false,
  placeholder = '○',
}) => {
  const bg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const focusBorderColor = useColorModeValue('blue.500', 'blue.300');
  const errorBorderColor = useColorModeValue('red.500', 'red.300');
  const textColor = useColorModeValue('gray.900', 'white');
  const placeholderColor = useColorModeValue('gray.400', 'gray.500');

  const handleChange = (otp: string) => {
    onChange?.(otp);
    if (otp.length === maxLength) {
      onComplete?.(otp);
    }
  };

  return (
    <FormControl isInvalid={isInvalid} isDisabled={isDisabled}>
      {label && (
        <FormLabel mb={3} fontSize="sm" fontWeight="medium">
          {label}
        </FormLabel>
      )}

      <VStack spacing={4} align="stretch">
        <Box display="flex" justifyContent="center">
          <OtpInput
            renderInput={(props) => <input {...props} />}
            value={value}
            onChange={handleChange}
            numInputs={maxLength}
            shouldAutoFocus
            inputStyle={{
              width: '48px',
              height: '48px',
              fontSize: '1.25rem',
              fontWeight: '600',
              textAlign: 'center',
              border: `1px solid #56B6A5`,
              borderRadius: '6px',
              backgroundColor: bg,
              color: textColor,
              outline: 'none',
              margin: '0 4px',
            }}
            // focusStyle={{
            //   border: `2px solid ${focusBorderColor}`,
            //   outline: 'none',
            // }}
            // separator={<span style={{ width: '8px' }}></span>}
            // isInputNum={true}
            // hasErrored=  {isInvalid}
            // errorStyle={{
            //   border: `2px solid ${errorBorderColor}`,
            // }}
            placeholder={placeholder}
            // inputProps={{
            //   'data-testid': 'otp-input',
            // }}
          />
        </Box>
      </VStack>

      {errorMessage && isInvalid && (
        <FormErrorMessage mt={2}>{errorMessage}</FormErrorMessage>
      )}

      {helperText && !isInvalid && (
        <FormHelperText mt={2}>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
};

export default InputOtp;
